module.exports = "table.DTCR_clonedTable.dataTable {\n  position: absolute !important;\n  background-color: rgba(255, 255, 255, 0.7);\n  z-index: 202;\n}\n\ndiv.DTCR_pointer {\n  width: 1px;\n  background-color: #0259c4;\n  z-index: 201;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./node_modules/datatables.net-colreorder-dt/css/colReorder.dataTables.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./node_modules/datatables.net-colreorder-dt/css/colReorder.dataTables.css
// module chunks = styles